<template>
  <v-container fluid>
    <v-row justify="start">
      <v-col
        class="text-h3 gray--text"
        cols="auto"
      > Biomicroscopia </v-col>

      <v-col cols="auto">
        <v-btn
          color="light-blue"
          @click="handleNormal()"
          :dark="!attendanceEsigned"
          :disabled="attendanceEsigned"
        >
          Normal
        </v-btn>
      </v-col>

      <v-col cols="5">
        <v-btn
          color="light-blue"
          @click="handleNormal(true)"
          :dark="!attendanceEsigned"
          :disabled="attendanceEsigned"
        >
          Normal Lio
        </v-btn>
      </v-col>
      <v-col
        class="text-h3 gray--text"
        cols="auto"
      > Tonometria </v-col>
    </v-row>

    <v-row>
      <v-col cols="2">
        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Local"
              :items="facilitatorSite"
              @change="handleFacilitatorChange(facilitator, '\n', ':')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Exame ocular externo"
              :items="facilitatorExternalExam"
              @change="handleFacilitatorChange(facilitator, ' ', ',')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Pálpepras E Cílios"
              :items="facilitatorEyelidsEyelashes"
              @change="handleFacilitatorChange(facilitator, ' ', ',')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Vias Lacrimais"
              :items="facilitator_TearDuct"
              @change="handleFacilitatorChange(facilitator, ' ', ',')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Tarso"
              :items="facilitatorTarsal"
              @change="handleFacilitatorChange(facilitator, ' ', ',')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Conjuntiva"
              :items="facilitatorConjunctiva"
              @change="handleFacilitatorChange(facilitator, ' ', ',')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Córnea"
              :items="facilitatorCornea"
              @change="handleFacilitatorChange(facilitator, ' ', ',')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Iris"
              :items="facilitatorIris"
              @change="handleFacilitatorChange(facilitator, ' ', ',')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Câmara anterior"
              :items="facilitatorAnteriorChamber"
              @change="handleFacilitatorChange(facilitator, ' ', ',')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Lente"
              :items="facilitatorLen"
              @change="handleFacilitatorChange(facilitator, ' ', ',')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Intensidade"
              :items="facilitatorIntensity"
              @change="handleFacilitatorChange(facilitator, '', ' ')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="6">
        <v-row dense>
          <v-col>
            <v-textarea
              v-model="biomicroscopy.description"
              v-uppercase
              solo
              dense
              :hide-details="!hasErrors"
              :error-messages="errors.description"
              rows="13"
              placeholder="Digite os dados da biomicroscopia..."
              background-color="white"
              auto-grow
              :disabled="attendanceEsigned"
              @input="handleDescriptionChange"
            />
          </v-col>
        </v-row>
        <v-row justify="end">
          <v-col cols="auto">
            <SaveStatus
              :saving="saveManager.isSaving"
              :pending="saveManager.pendingSave"
              :saved-at="biomicroscopy.updatedAt"
              :loading="biomicroscopyLoading"
              :error="hasErrors || saveManager.isError"
              not-saved-message="A Biomicroscopia ainda não foi salva."
            />
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="light-blue"
              dark
              @click="saveManager.triggerManualSave()"
              :loading="isLoading || saveManager.isSaving"
              :disabled="attendanceEsigned"
            >
              Salvar Biomicroscopia
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row dense>
              <v-col class="text-h5 gray--text">
                Olho direito
              </v-col>
              <v-col class="text-h5 gray--text">
                Olho esquerdo
              </v-col>
            </v-row>

            <v-row dense>
              <v-col v-if="biomicroscopy.internalRight">
                <FileUpload
                  ownerType="Biomicroscopy::InternalRight"
                  :ownerId="biomicroscopy.internalRight.id"
                  :disabled="attendanceEsigned"
                />
              </v-col>

              <v-col v-if="biomicroscopy.internalLeft">
                <FileUpload
                  ownerType="Biomicroscopy::InternalLeft"
                  :ownerId="biomicroscopy.internalLeft.id"
                  :disabled="attendanceEsigned"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col class="text-h5 gray--text">
            Imagens Externas
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row dense>
              <v-col class="text-h5 gray--text">
                Olho direito
              </v-col>
            </v-row>

            <v-row dense>
              <v-col v-if="biomicroscopy.externalRight">
                <FileUpload
                  ownerType="Biomicroscopy::ExternalRight"
                  :ownerId="biomicroscopy.externalRight.id"
                  :disabled="attendanceEsigned"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col>
            <v-row dense>
              <v-col class="text-h5 gray--text">
                Olho esquerdo
              </v-col>
            </v-row>

            <v-row dense>
              <v-col v-if="biomicroscopy.externalLeft">
                <FileUpload
                  ownerType="Biomicroscopy::ExternalLeft"
                  :ownerId="this.biomicroscopy.externalLeft.id"
                  :disabled="attendanceEsigned"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4">
        <BreathTonometry :attendance="attendance" />
        <ApplanationTonometry :attendance="attendance" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BIOMICROSCOPY_FACILITATORS from "@/graphql/biomicroscopy/biomicroscopy_facilitators.gql";
import GET_BIOMICROSCOPY from "@/graphql/biomicroscopy/biomicroscopy.gql";
import SAVE_BIOMICROSCOPY from "@/graphql/biomicroscopy/save_biomicroscopy.gql";

import ApplanationTonometry from "@/components/medical_record/biomicroscopy/applanation_tonometry.vue"
import BreathTonometry from "@/components/medical_record/biomicroscopy/breath_tonometry.vue"
import SaveStatus from "@/components/ui/form/save_status/index.vue";

import { AutoSaveManager } from "@/services/AutoSaveManager/index.js";

export default {
  name: "BIOMICROSCOPY",
  props: {
    attendance: Object,
    attendanceEsigned: Boolean,
  },
  components: {
    ApplanationTonometry,
    SaveStatus,
    BreathTonometry
  },
  data() {
    return {
      biomicroscopyFacilitators: [],
      biomicroscopy: {},
      facilitator: [],
      saveManager: null,
      errors: {},
    };
  },
  apollo: {
    biomicroscopyFacilitators: {
      query: BIOMICROSCOPY_FACILITATORS,
    },
    biomicroscopy: {
      query: GET_BIOMICROSCOPY,
      fetchPolicy: "no-cache",
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
      watchLoading(isLoading) {
        if (isLoading) {
          this.$store.dispatch("updateLoading", true);
        } else {
          setTimeout(() => {
            this.$store.dispatch("updateLoading", false);
          }, 1000);
        }
      },
    },
  },
  created() {
    this.saveManager = new AutoSaveManager({
      formName: "Biomicroscopia",
      beforeSave: () => this.beforeSave(),
      onSave: () => this.onSave(),
      autoSaveTimeout: 900000, // 15 minutes
    });
  },
  watch: {
    $route() {
      this.triggerManualSave();
    },
  },
  computed: {
    isLoading() {
      return (
        this.biomicroscopyLoading || this.$apollo.queries.biomicroscopyFacilitators.loading
      );
    },
    biomicroscopyLoading() {
      return !this.biomicroscopy.id;
    },
    facilitatorSite() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "site",
      });
    },
    facilitatorExternalExam() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "external_exam",
      });
    },
    facilitatorEyelidsEyelashes() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "eyelids_and_eyelashes",
      });
    },
    facilitator_TearDuct() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "tears_duct",
      });
    },
    facilitatorTarsal() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "tarsal",
      });
    },
    facilitatorConjunctiva() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "conjunctiva",
      });
    },
    facilitatorCornea() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "cornea",
      });
    },
    facilitatorIris() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "iris",
      });
    },
    facilitatorAnteriorChamber() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "anterior_chamber",
      });
    },
    facilitatorLen() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "len",
      });
    },
    facilitatorIntensity() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "intensity",
      });
    },
    orderedfacilitators() {
      return this.lodash.orderBy(
        this.biomicroscopyFacilitators,
        [
          (e) =>
            e.text
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
    hasErrors() {
      return Object.keys(this.errors).length > 0;
    },
  },
  methods: {
    handleFacilitatorChange(e, textBefore = "", textAfter = "") {
      if (this.attendanceEsigned) return;

      if (e) {
        if (this.verifyDescription()) {
          this.biomicroscopy.description = ` ${e.text}${textAfter}`;
        } else if (this.biomicroscopy.description.slice(-1) === ":") {
          this.biomicroscopy.description += `${e.text}${textAfter}`;
        } else
          this.biomicroscopy.description += ` ${textBefore}${e.text}${textAfter}`;
      }

      this.facilitator = [];
      this.saveManager.dispatchAutoSave();
    },
    verifyDescription() {
      return (this.biomicroscopy.description === null || this.biomicroscopy.description.trim() === "");
    },
    handleDescriptionChange() {
      this.saveManager.dispatchAutoSave();
    },
    handleNormal(normalLio) {
      if (this.attendanceEsigned) return;

      let text = "CONJUNTIVA CLARA, CÓRNEA TRANSPARENTE, CÂMARA ANTERIOR OPTICAMENTE VAZIA, ÍRIS REAGENTE, LENTE TRANSLÚCIDA";
      if (normalLio) text = "CONJUNTIVA CLARA, CÓRNEA TRANSPARENTE, CÂMARA ANTERIOR OPTICAMENTE VAZIA, ÍRIS REAGENTES, LENTE INTRA-OCULAR POSTERIOR TÓPICA";

      if (this.biomicroscopy) {
        if (this.biomicroscopy.description !== null) {
          this.biomicroscopy.description += ` ${text}, `;
          this.biomicroscopy.description = this.biomicroscopy.description.trim();
        } else {
          this.biomicroscopy.description = `${text}, `;
        }
      }

      this.facilitator = [];
    },
    validateBiomicroscopy() {
      this.errors = {};

      if (!this.biomicroscopy.description?.trim()) {
        this.errors.description = "A Biomicroscopia não pode estar vazia.";
      }
    },
    beforeSave() {
      this.validateBiomicroscopy();
      if (this.attendanceEsigned) return false;
      if (this.hasErrors) return false;
      return true;
    },
    async onSave() {
      const { data } = await this.apolloMutate({
        mutation: SAVE_BIOMICROSCOPY,
        variables: {
          attendanceId: this.attendance.id,
          description: this.biomicroscopy.description,
        },
      });
      this.$set(this.biomicroscopy, "updatedAt", data.saveBiomicroscopy.updatedAt);
    },
  },
};
</script>

<style lang="scss" scoped></style>
